var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliAlertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.285,
    height: 28.284,
    viewBox: "0 0 28.285 28.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72901",
    "data-name": "Group 72901",
    transform: "translate(-9286 12302.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2626",
    "data-name": "Rectangle 2626",
    transform: "translate(9300.143 -12302.143) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72040",
    "data-name": "Group 72040",
    transform: "translate(9941.146 -12248) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V5",
    transform: "translate(641 44) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H.009",
    transform: "translate(641.006 36) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliAlertLight);
export default __webpack_public_path__ + "static/media/compli-alert-light.45750534c8650a4ee4944e584ad15b07.svg";
export { ForwardRef as ReactComponent };